<template lang="pug"> 
  v-row
    v-col(cols=12)
      h3 {{ $t('lasted-result') }}
    v-col(cols=12)
      v-card.mt-5.py-3.text-center.red--text(v-if='win_number.length===0' flat)
        h3 {{ $t('operating-result') }}
      div(v-else)
        one-column-card(v-if='isCardOneColumn(gameType.id)', :item='win_number')
        two-column-card(v-else-if='isCardTwoColumn(gameType.id)', :item='win_number')
        three-column-card(v-else-if='IsYeekeeType(gameType.id)', :lotto-name="lottoName" :item='win_number')
        four-column-card(v-else-if='isCardFourColumn(gameType.id)', :item='win_number')
    
    v-col(cols=12)
      v-row(
        v-if='IsYeekeeType(gameType.id) && winner' 
        no-gutters
      )
        v-col.text-center(
          v-if='winner.user_first_rank' 
          cols=6
        )
          v-row
            v-col(cols='12')
              b {{ $t('total-shot-number') }}
            v-col(cols='12')
              | {{ winner.sum_results || '' }}
            v-col(cols='12')
              b {{ $t('member-shoot-number-no-one') }}
            v-col(cols='12')
              | {{ winner.user_first_rank.username || '' }}
        v-col.text-center(
          v-if='winner.user_sixteenth_rank&&items.length!==0' 
          cols=6
        )
          v-row
            v-col(cols='12')
              b {{ $t('row-number-sixteen') }}
            v-col(cols='12')
              | {{ items[15].number || '' }}
            v-col(cols='12')
              b {{ $t('member-shoot-number-no-sixteen') }}
            v-col(cols='12')
              | {{ winner.user_sixteenth_rank.username || '' }}
      
    v-col(
      v-if='items.length!==0'
      cols=12
    )
      v-row(no-gutters justify="center")
        h2 {{ $t('history-shoot-number') }}
      v-simple-table.mt-5(fixed-header)
        template(v-slot:default)
          thead
            tr
              th.text-left
                | {{ $t('table.sequence') }}
              th.text-left
                | {{ $t('table.number') }}
              th.text-left
                | {{ $t('table.member') }}
              th.text-left
                | {{ $t('table.time-sent') }}
          tbody
            tr(
              v-for='(item,i) in items'
              :key='i'
              :class="item.rank_no===1? 'orange' : item.rank_no===16 ? 'yellow' :''"
            )
              td {{ item.rank_no || '' }}
              td {{ item.number || '' }}
              td {{ item.username || '' }}
              td {{ item.created_at || '' }}
      n-pagination(
        :meta='meta'
        :page='page'
        @nextpage='nextpage'
      )
    v-col(cols=12)
      v-card(v-if='items.length===0 && ruleLotto' flat).pa-5
        v-col
          .optimizeWidth(v-html="formattedContent(ruleLotto)")

</template>
<script>  
import { gameRooms as apiGameRooms } from '@/apis'
import { formattedContent } from '@/plugins/helper'
import { 
  IsYeekeeType,  
  CARD_TWO_COLUMN,
  CARD_FOUR_COLUMN,
  CARD_ONE_COLUMN
} from '@/const/gameId' 
import { IsGameCanUserVoucher } from '@/const/gameId'
import { ROUTE_GAME_LOTTO_DETAIL } from '@/const/route'
import * as c from '@/const/setTimeOutConfig'  
export default { 

  props : {
    ruleLotto : {
      type : String,
      default : null
    }, 
    gameType : {
      type : Object,
      default : ()=>{}
    },
    lottoName : {
      type : String,
      default : null
    },
  },

  data: () => ({ 
    page:1,
    items : [],
    meta:{}, 
    win_number:[],
    winner:null, 
  }),

  computed : {
    gameId () {
      return this.$route.query.id
    },

    routeName () {
      return this.$route.name
    }
  },

  watch: {
    async gameId () {
      this.winner = null
      this.win_number = []
      // await this.loadSummary()
    }
  },

  async mounted () {
    await this.loadSummary()
  },

  methods:{
    IsYeekeeType,
    formattedContent,
    isCardTwoColumn: (id) => CARD_TWO_COLUMN.includes(id),
    isCardFourColumn: (id) => CARD_FOUR_COLUMN.includes(id),
    isCardOneColumn: (id) => CARD_ONE_COLUMN.includes(id), 
    nextpage (value) {
      this.page = value
      this.load ()
    }, 

    async load (params = {}) { 

      params.page = this.page
      if(!IsGameCanUserVoucher((this.gameType || {}).id)) return
      const [err, data,,meta] = await apiGameRooms.getResultHistory(this.gameId,params)

      if(err){
        this.$alert('',err,'warning')
        return
      } 
        
      this.items = data || []
      this.meta = meta  
    }, 

    async fetchData () {
      setTimeout(() => {
        if(this.win_number.length===0 && this.routeName === ROUTE_GAME_LOTTO_DETAIL) { 
          this.loadSummary() 
        } 
      }, c.FETCHRESULTGAME)
    },
    
    async loadSummary (params = {}) {
      params.page = this.page

      const [err, data] = await apiGameRooms.getResultSummary(this.gameId,params)


      if(err){
        this.$alert('',err,'warning')
        return
      } 
       
      //pull request for waiting winner data
      if(data.win_number){  
        this.load ()
        this.win_number.push(data.win_number) 
        this.winner = data.winner 
      } else {
        this.fetchData()   
      } 
    },
  } 
}
</script>   